module.exports = __webpack_public_path__ + "img/logo-shiba888.7b50586a.png";